module.exports = __webpack_public_path__ + "static/media/rm_06-14.f68bb6bd.png";